import { useState } from 'react';
import { getNextPhaseStep, getLastPhaseStep, getFirstPhaseStep, getPrevPhaseStep } from '../../shared/utils/phase';

// Custom hook pro použití kroků fáze - aktivní krok fáze + funkce pro změnu aktivního kroku fáze
export const usePhaseStep = (activePhase, initialPhaseStep) => {
    const [activePhaseStep, setActivePhaseStep] = useState(initialPhaseStep || activePhase.steps[0]);

    const setNextPhaseStep = () => {
        setActivePhaseStep((currentPhaseStep) => {
            const lastPhaseStep = getLastPhaseStep(activePhase);

            if (currentPhaseStep === lastPhaseStep) {
                console.error('Cannot set next phase step! This is last phase step');
                return currentPhaseStep;
            }

            const nextPhaseStep = getNextPhaseStep(activePhase, currentPhaseStep);

            return nextPhaseStep;
        });
    };

    const setPrevPhaseStep = () => {
        setActivePhaseStep((currentPhaseStep) => {
            const firstPhaseStep = getFirstPhaseStep(activePhase);

            if (currentPhaseStep === firstPhaseStep) {
                console.error('Cannot set previous phase step! This is first phase step');
                return currentPhaseStep;
            }

            const prevPhaseStep = getPrevPhaseStep(activePhase, currentPhaseStep);

            return prevPhaseStep;
        });
    };

    const setSpecificPhaseStep = (phaseStep) => {
        if (!phaseStep && phaseStep !== 0) {
            console.error('Cannot set phase step! Phase step is ', phaseStep);
            return;
        }

        if (phaseStep < 1 || phaseStep > 4) {
            console.error('Cannot set phase step! Phase step must be in range [1-4], but was: ', phaseStep);
            return;
        }

        const containsPhaseStep = activePhase.steps.includes(phaseStep);

        if (!containsPhaseStep) {
            console.error('Cannot set phase step! Phase step is not in current active phase');
            return;
        }

        setActivePhaseStep(phaseStep);
    };

    const resetPhaseStep = () => {
        setActivePhaseStep(getFirstPhaseStep(activePhase));
    };

    return {
        activePhaseStep,
        setNextPhaseStep,
        resetPhaseStep,
        setSpecificPhaseStep,
        setPrevPhaseStep,
    };
};
